import { render } from "./App.vue?vue&type=template&id=27ef0531"
const script = {}

import exportComponent from "/Users/ym/Desktop/tianmuli/tml-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__